import { Trans } from '@lingui/react'
import { func, number, oneOfType, shape, string } from 'prop-types'

import InputTextWithFloatingLabel from 'views/components/molecules/InputTextWithFloatingLabel'
import {
  firstNameFieldValidator,
  lastNameFieldValidator,
} from 'views/utils/formValidationHelper'

const AddressFirstLastName = ({ type, register, errors, watch, maxLength }) => {
  return (
    <ul className="l-grid l-grid--tight">
      <li className="l-grid__item l-col--6-of-12 u-margin--bottom">
        <InputTextWithFloatingLabel
          name="firstName"
          id={`${type ? `${type}-` : ''}firstName`}
          inputType="text"
          required
          register={register ? register(firstNameFieldValidator) : null}
          errors={errors}
          watch={watch ? watch('firstName') : undefined}
          maxLength={maxLength}
        >
          <Trans id="general.label.firstName" />
        </InputTextWithFloatingLabel>
      </li>
      <li className="l-grid__item l-col--6-of-12 u-margin--bottom">
        <InputTextWithFloatingLabel
          name="lastName"
          id={type ? `${type}-lastName` : 'lastName'}
          inputType="text"
          required
          register={register ? register(lastNameFieldValidator) : null}
          errors={errors}
          watch={watch ? watch('lastName') : undefined}
          maxLength={maxLength}
        >
          <Trans id="general.label.surname" />
        </InputTextWithFloatingLabel>
      </li>
    </ul>
  )
}

AddressFirstLastName.propTypes = {
  type: string,
  register: func,
  watch: func,
  errors: shape({}),
  maxLength: oneOfType([string, number]),
}
AddressFirstLastName.defaultProps = {
  type: null,
  register: null,
  watch: null,
  errors: null,
  maxLength: undefined,
}

export default AddressFirstLastName
